<template>
    <div>
        <el-dialog title="制作事件报告"  :visible.sync="visible" :close-on-click-modal="false" width="50%" :lock-scroll="true">

            <div>
                <el-form label-position="right"
                         label-width="120px">
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="报告责任人" >
                                <el-select v-model="username" placeholder="请选择" clearable filterable>
                                    <el-option
                                            v-for="item in sysUserList"
                                            :key="item.username"
                                            :label="item.realname"
                                            :value="item.username">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="save">确定</el-button>
                <el-button @click.native="visible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {makeReport
    } from '@/api/ticket/ticketRestructure/list.js'
    export default {
        name: 'makeEventReport',
        components: {},
        data() {
            return {
                visible: false,
                sysUserList:[],
                username:null,
                ticketid:null,
            }
        },
        methods: {
             save(){
                if(this.username==null||this.username==''){
                    this.$message.success('请选择报告责任人');
                    return;
                }
                this.$confirm('确定制作事件报告', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async() => {
                    var realname=null;
                    for(var a=0;a<this.sysUserList.length;a++){
                        if(this.sysUserList[a].username==this.username){
                            realname=this.sysUserList[a].realname;
                            break;
                        }
                    }
                    var param = {
                        'ticketId' : this.ticketid,
                        'maker': localStorage.getItem("realname"),
                        'username':this.username,
                        'realname':realname,
                        'token':localStorage.getItem("token"),
                        'appId':'WEB'
                    };
                    var url = "/ticket/makeReport";
                    var response=await makeReport(url,param);
                    if(response.code == 200){
                        this.$message.success(response.message);
                        //response.data;
                        this.visible=false;
                        //调用父页面方法显示当前详情事件的工作流状态
                        this.$emit('createdReport');
                    }
                }).catch(() => {
                    console.log('已取消选择');
                });

            },

        }
    }
</script>

